import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Card — a panel with a heading.
 *
 * `titleAs` exists because heading level is a document concern, not a component one: a card in a
 * page's main column is usually an h2, the same card inside a section is an h3, and getting that
 * wrong breaks the heading outline a screen-reader user navigates by (WCAG 1.3.1).
 */
import {} from 'react';
import { cx } from '../lib/cx.js';
export function Card({ title, titleAs: Heading = 'h2', description, footer, variant = 'default', className, children, ...rest }) {
    return (_jsxs("div", { ...rest, className: cx('clav-card', variant !== 'default' && `clav-card--${variant}`, className), children: [title ? _jsx(Heading, { className: "clav-card__title", children: title }) : null, description ? _jsx("p", { className: "clav-card__description", children: description }) : null, children, footer ? _jsx("div", { className: "clav-card__footer", children: footer }) : null] }));
}
//# sourceMappingURL=card.js.map